/**
 * Constantes partagees du wizard ajout offre.
 * - ZONE_CARDS : les zones du modele (enum ProductCategory.zone : ALIMENTAIRE /
 *   ARTISANAT / BIEN_ETRE / SERVICES / DIVERS), "Autre" agregeant SERVICES +
 *   DIVERS. Depuis S71 elles ne servent plus que d'intertitres a la liste des
 *   rayons du parcours « proposer » (plus de cartes de zone, prototype).
 * - UNITES / UNITES_VENTE : unites de vente proposees aux producteurs.
 */

export const ZONE_CARDS = [
  {
    key: 'ALIMENTAIRE',
    label: 'Alimentaire',
    emoji: '🥖',
    desc: 'Fruits, legumes, viande, poisson, transforme, restauration',
    zones: ['ALIMENTAIRE'],
  },
  {
    key: 'ARTISANAT',
    label: 'Artisanat',
    emoji: '🎨',
    desc: 'Creations artisanales non-alimentaires',
    zones: ['ARTISANAT'],
  },
  {
    key: 'BIEN_ETRE',
    label: 'Bien-etre',
    emoji: '💆',
    desc: 'Cosmetiques, hygiene, soins',
    zones: ['BIEN_ETRE'],
  },
  {
    key: 'AUTRE',
    label: 'Autre',
    emoji: '✨',
    desc: 'Services, ateliers, divers',
    zones: ['SERVICES', 'DIVERS'],
  },
]

// Unites de vente — miroir de `apps/backend/src/modules/products/units.ts`
// (lot 1, retour Enzo 23 juil : trois listes divergentes ignoraient l'unite du
// produit). Regle : une offre se vend dans une unite de MEME NATURE que son
// produit — en grammes un produit au kilo, oui ; au litre, jamais.
export const UNITES = [
  { value: 'kg', label: 'kg', nature: 'MASSE' },
  { value: 'g', label: 'g', nature: 'MASSE' },
  { value: 'L', label: 'L', nature: 'VOLUME' },
  { value: 'cL', label: 'cL', nature: 'VOLUME' },
  { value: 'unite', label: 'unité', nature: 'DENOMBREMENT' },
  { value: 'piece', label: 'pièce', nature: 'DENOMBREMENT' },
  { value: 'botte', label: 'botte', nature: 'DENOMBREMENT' },
  { value: 'bouquet', label: 'bouquet', nature: 'DENOMBREMENT' },
  { value: 'barquette', label: 'barquette', nature: 'DENOMBREMENT' },
  { value: 'pack', label: 'pack', nature: 'DENOMBREMENT' },
]

export function natureDe(value) {
  return UNITES.find((u) => u.value === value)?.nature || 'DENOMBREMENT'
}

/** Unites proposables pour un produit : celles de sa nature. */
export function unitesCompatibles(uniteProduit) {
  const nature = natureDe(uniteProduit)
  return UNITES.filter((u) => u.nature === nature)
}


// « Vous le vendez… » (prototype v7.4, WizardOffre/unite) : cinq unites en
// toutes lettres, puis « Autre ». Les valeurs sont celles du backend (units.ts).
export const UNITES_VENTE = [
  { value: 'kg', label: 'le kg' },
  { value: 'piece', label: 'la pièce' },
  { value: 'botte', label: 'la botte' },
  { value: 'L', label: 'le litre' },
  { value: 'barquette', label: 'la barquette' },
]

/** Libelle court d'une unite (« kg », « pièce »…), la valeur brute a defaut. */
export const libelleUnite = (value) => UNITES.find((u) => u.value === value)?.label || value || 'kg'
